import { createFileRoute, redirect } from "@tanstack/react-router";

// Formerly a second path onto the Developer settings page (both `/developer`
// and `/developer/email` rendered one component). #703 dropped its nav link
// without retiring the route; the sidebar IA reorg retires the page itself, so
// this finally becomes what it has effectively been — a redirect.
export const Route = createFileRoute("/dashboard/w/$workspaceId/developer/email")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/developer/webhook",
      params: { workspaceId: params.workspaceId },
    });
  },
});
